import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_I18N_LANGUAGE_CODES,
} from './languages';

import deTranslations from './locales/de.json';
import enTranslations from './locales/en.json';
import itTranslations from './locales/it.json';
import sqTranslations from './locales/sq.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_I18N_LANGUAGE_CODES],
    nonExplicitSupportedLngs: true,
    cleanCode: true,
    load: 'languageOnly',
    ns: ['translation'],
    defaultNS: 'translation',
    resources: {
      al: {
        translation: sqTranslations,
      },
      de: {
        translation: deTranslations,
      },
      en: {
        translation: enTranslations,
      },
      it: {
        translation: itTranslations,
      },
      sq: {
        translation: sqTranslations,
      },
    },
    interpolation: {
      escapeValue: false,
    },
    returnEmptyString: false,
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;

